import { render, staticRenderFns } from "./InstagramFilter.vue?vue&type=template&id=8086e4ba&scoped=true&"
import script from "./InstagramFilter.vue?vue&type=script&lang=js&"
export * from "./InstagramFilter.vue?vue&type=script&lang=js&"
import style0 from "./InstagramFilter.vue?vue&type=style&index=0&id=8086e4ba&lang=scss&scoped=true&"
import style1 from "./InstagramFilter.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./InstagramFilter.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8086e4ba",
  null
  
)

export default component.exports